/* eslint-disable @typescript-eslint/no-explicit-any */
import type { RootState } from '~publish/legacy/store'
import { tagFormSlice } from './slice'
import type { LeanTag } from '~publish/legacy/campaign/types'

export const selectTagFormProperties = (
  state: RootState,
): { editMode: boolean; isFromSelector: boolean; isLoading: boolean } => {
  const { editMode, isFromSelector, isLoading } = (state as any)[
    tagFormSlice.name
  ] as {
    editMode: boolean
    isFromSelector: boolean
    isLoading: boolean
  }
  return { editMode, isFromSelector, isLoading }
}

export const selectTagInfo = (state: RootState): LeanTag | null => {
  const { tag } = (state as any)[tagFormSlice.name] as {
    tag: LeanTag | null
  }
  return tag
}
